import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import Facebook from "../../assets/icons/facebook.svg";
import Insta from "../../assets/icons/insta.svg";
import Linkedin from "../../assets/icons/linkedin.svg";
import Youtube from "../../assets/icons/youtube.svg";
import Call from "../../assets/icons/call.svg";
import Email from "../../assets/icons/email.svg";
import Location from "../../assets/icons/gps.svg";
import "./index.css";
import { useTranslation } from "react-i18next";
import Logo from "../../assets/images/logo.svg";
import CookieSettingsButton from "../CookieSettingsButton";

const PARTNER_EMAIL = process.env.REACT_APP_PARTNER_EMAIL || "";
const PARTNER_ADDRESS = process.env.REACT_APP_PARTNER_ADDRESS || "";
const PARTNER_PHONE = process.env.REACT_APP_PARTNER_PHONE || "";
const PARTNER_NAME = process.env.REACT_APP_PARTNER_NAME || "";
const Index = () => {
  const { t } = useTranslation();

  return (
    <footer>
      <Container>
        <div className="footer_wrapper">
          <Row className="m-0">
            <Col lg={4} className="p-0 first_col">
              <div className="firs_col_wrapper">
                <h5>
                  <img src={Logo} alt="Logo" style={{ width: "200px", marginLeft: "-25px" }} />
                </h5>
                <p>{t("slogan_short")}</p>

                <p>{t("slogan_long")}</p>
              </div>
              <ul className="social_link d-sm-flex d-none">
                <li>
                  <Link>
                    <img src={Facebook} alt="facebook" />
                  </Link>
                </li>
                <li>
                  <Link>
                    <img src={Insta} alt="insta" />
                  </Link>
                </li>
                <li>
                  <Link>
                    <img src={Linkedin} alt="linkedin" />
                  </Link>
                </li>
                <li>
                  <Link>
                    <img src={Youtube} alt="Youtube" />
                  </Link>
                </li>
              </ul>
            </Col>
            <Col lg={7} className="links_wrapper">
              <Row>
                <Col lg={3} xs={6} className="links">
                  <h5>{t("quick_link")}</h5>
                  <ul>
                    <li>
                      <a
                        href={`https://app.quotabus.com/${process.env.REACT_APP_PARTNER_CODE}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {t("get_quote")}
                      </a>
                    </li>
                    <li>
                      <a href="#how_it_work_sec">{t("how_it_works")}</a>
                    </li>
                    <li>
                      <a href="#faqs">{t("faq")}</a>
                    </li>
                  </ul>
                </Col>
                <Col lg={3} xs={6} className="links">
                  <h5>{t("important_links")}</h5>
                  <ul>
                    <li>
                      <a href="#contact_form">{t("contact_us")}</a>
                    </li>
                  </ul>
                </Col>
                <Col lg={4} xs={6} className="links contcat_info">
                  <h5>{t("contact_info")}</h5>
                  <ul>
                    <li>
                      <div>
                        <div className="icon_box">
                          <img src={Email} alt="email" />
                        </div>
                        <a
                          href={`mailto:${PARTNER_EMAIL}`}
                          className="contact_email"
                        >
                          {PARTNER_EMAIL}
                        </a>
                      </div>
                    </li>
                    <li>
                      <div>
                        <div className="icon_box">
                          <img src={Call} alt="phone" />
                        </div>
                        <a
                          href={`tel:${PARTNER_PHONE}`}
                          className="contact_phone"
                        >
                          {PARTNER_PHONE}
                        </a>
                      </div>
                    </li>
                    <li>
                      <div>
                        <span className="icon_box">
                          <img src={Location} alt="location" />
                        </span>
                        <span className="contact_address">
                          {PARTNER_ADDRESS}
                        </span>
                      </div>
                    </li>
                  </ul>
                  <ul className="social_link d-sm-none d-flex">
                    <li>
                      <Link>
                        <img src={Facebook} alt="facebook" />
                      </Link>
                    </li>
                    <li>
                      <Link>
                        <img src={Insta} alt="insta" />
                      </Link>
                    </li>
                    <li>
                      <Link>
                        <img src={Linkedin} alt="linkedin" />
                      </Link>
                    </li>
                    <li>
                      <Link>
                        <img src={Youtube} alt="Youtube" />
                      </Link>
                    </li>
                  </ul>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
        <div className="copyright">
          <p>© {new Date().getFullYear()} {PARTNER_NAME}. All Rights Reserved</p>
          <CookieSettingsButton
            className="cookie_settings_button"
            variant="compact"
          />
        </div>
      </Container>
    </footer>
  );
};

export default Index;
